// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"34a7e262","220":"30c80235","641":"e1a107d8","865":"0aa5df5d","989":"da9fddd2"}[chunkId] + ".chunk.js";
};